import type { CSSProperties } from "react";
import { cssClass } from "./constant";

/**
 * Speaker icon size as a fraction of the card, so it scales when the element is
 * resized on the canvas. Shared so web and mobile stay in sync.
 */
export const AUDIO_ICON_RATIO = 0.5;

export type AudioPlayerStyles = {
  outerDiv: CSSProperties;
  playingColor: CSSProperties;
  iconWrapper: CSSProperties;
  text: CSSProperties;
};

export const audioPlayerStyles: AudioPlayerStyles = {
  outerDiv: {
    width: "100%",
    height: "100%",
    ...cssClass.centerFlex,
    overflow: "hidden",
    color: "#989898",
    fontSize: "2rem",
    ...cssClass.button,
    borderRadius: "1.2rem",
  },
  // The speaker icon doubles as the progress bar: a gray icon with an orange copy
  // clipped left to right on top of it. Square regardless of the card's aspect
  // ratio, so the clip percentage always lines up with the drawn glyph.
  iconWrapper: {
    position: "relative",
    width: `${AUDIO_ICON_RATIO * 100}%`,
    aspectRatio: 1,
  },
  playingColor: {
    color: "#FF9433",
  },
  text: {
    fontSize: "2rem",
    fontWeight: "bolder",
  },
};
